import { CrashlyticsService } from './crashlytics.service';
import { inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoggingService {
  // tslint:disable-next-line:member-access
  readonly #crashlytics = inject(CrashlyticsService);

  public debug(message: string, ...optionalParams: any[]) {
    // tslint:disable-next-line:no-console
    console.debug(message, ...optionalParams);
    this.logToCrashlytics('DEBUG', message, optionalParams);
  }

  public log(message: string, ...optionalParams: any[]) {
    console.log(message, ...optionalParams);
    this.logToCrashlytics('LOG', message, optionalParams);
  }

  public info(message: string, ...optionalParams: any[]) {
    console.log(message, ...optionalParams);
    this.logToCrashlytics('INFO', message, optionalParams);
  }

  public error(message: string, ...optionalParams: any[]) {
    console.error(message, ...optionalParams);
    this.logToCrashlytics('ERROR', message, optionalParams);
    this.sendParamToCrashlyticsIfItsAnError(optionalParams);
  }

  public warn(message: string, ...optionalParams: any[]) {
    console.warn(message, ...optionalParams);
    this.logToCrashlytics('WARN', message, optionalParams);
    this.sendParamToCrashlyticsIfItsAnError(optionalParams);
  }

  private logToCrashlytics(level: string, message: any, ...optionalParams: any[]) {
    const formattedMessage = `[${level}] ${message} ${optionalParams.length ? JSON.stringify(optionalParams) : ''}`;
    this.#crashlytics.log(formattedMessage);
  }

  private sendParamToCrashlyticsIfItsAnError(optionalParams: any[]) {
    for (const param of optionalParams) {
      if (param instanceof Error) {
        this.#crashlytics.sendStackTrace(param);
      }
    }
  }
}
